import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services/api';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { type BookmarkMutationParams, useUpdateBookmark } from 'features/feed/queries/hooks';
import { unbookmarkObject } from '../../services';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, "Something went wrong. Couldn't be unbookmarked right now.");
};

export const useUnbookmarkObjectMutation = () => {
  const updateCache = useUpdateBookmark();

  return useMutation<unknown, BookmarkMutationParams>({
    defaultMutateOnError,
    mutationFn: async (params) => unbookmarkObject(params.type === 'node' ? params.event.id : params.contentObject.id),
    onSuccess(_, params) {
      updateCache(params);
    },
  });
};
